import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logoutUser } from '../../slices/thunk';

const Logout = () => {
    const dispatch: any = useDispatch();
    const history : any = useNavigate();

    useEffect(() => {
        dispatch(logoutUser(history));
        // router.push('/auth-login', undefined, { shallow: true })
    }, [dispatch, history])

  return (
    <React.Fragment>
      
    </React.Fragment>
  )
}

export default Logout
